export default __webpack_public_path__ + "static/media/CityLights07.0940d85e.jpg";